import { ChipRemovable, Detail, List, Popover } from '@farol-ds/react'
import { destroyJusbrasilCookie, getCookie } from '@jusbrasil-web/shared-utils-cookies'
import { useContext } from 'react'

import { TopbarContext } from '../../context'
import { useForcedExperiment } from '../../hooks'
import styles from './topbar-dev-chips.module.scss'

export const TopbarDevChips = () => {
  const { user } = useContext(TopbarContext)

  const { forcedExperimentData, hasForcedExperiment, deleteForcedExperimentMutation } =
    useForcedExperiment()

  if (!user?.admin) return null

  const stagingCookieName = 'feature_staging'
  const isStaging = getCookie(null, stagingCookieName) === 'true'

  const onRemoveStagingCookie = () => {
    destroyJusbrasilCookie(null, stagingCookieName)
    window.location.reload()
  }

  const onDeleteForcedExperimentMutation = () => {
    deleteForcedExperimentMutation()
  }

  if (!isStaging && !hasForcedExperiment) return null

  return (
    <div className={styles.chipsContainer}>
      {isStaging && (
        <ChipRemovable className={styles.chip} onRemove={onRemoveStagingCookie}>
          STAGING
        </ChipRemovable>
      )}
      {hasForcedExperiment && (
        <Popover defaultOpen placement="bottom" type="light">
          <Popover.Trigger>
            <button>
              <ChipRemovable className={styles.chip} onRemove={onDeleteForcedExperimentMutation}>
                FORCED EXPERIMENT
              </ChipRemovable>
            </button>
          </Popover.Trigger>
          <Popover.Content className={styles.popoverContent}>
            <Popover.ContentDescription className={styles.popoverContentDescription} asChild>
              <div>
                <List>
                  <List.Item>
                    <Detail inline>
                      <Detail.Label>Grupo: </Detail.Label>
                      <Detail.Value>{forcedExperimentData?.group}</Detail.Value>
                    </Detail>
                  </List.Item>
                  <List.Item>
                    <Detail inline>
                      <Detail.Label>Experimento: </Detail.Label>
                      <Detail.Value>{forcedExperimentData?.experiment}</Detail.Value>
                    </Detail>
                  </List.Item>
                  <List.Item>
                    <Detail inline>
                      <Detail.Label>Variante: </Detail.Label>
                      <Detail.Value>{forcedExperimentData?.alternative}</Detail.Value>
                    </Detail>
                  </List.Item>
                </List>
              </div>
            </Popover.ContentDescription>
          </Popover.Content>
        </Popover>
      )}
    </div>
  )
}
